export enum AlertType {
  CriticalIssuesBanner = 'criticalIssuesBanner',
}
